import React, { useState, useRef } from 'react'
import * as styles from './MfaForm.css'
import { signInExternalHost, signInExternalHostWithCustomRedirect } from '../ExternalHosts'
import { signIn } from '../Auth'
import ALERT_TYPES from '../SharedConstants/AlertTypes'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'
import Logger from '../Logger'
import LoadingBar from 'react-top-loading-bar'
require('dotenv').config()

export default function MfaForm (props) {
  const { cognitoUser, destination } = props
  const [code, setCode] = useState('')
  const [alertType, setAlertType] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const loadingRef = useRef(null)
  const params = new URLSearchParams(window.location.search)
  const returnToUrl = params.get('return_to')

  const handleSubmit = (e) => {
    Logger.start('MFA submit')
    loadingRef.current.continuousStart()
    e.preventDefault()

    cognitoUser.sendMFACode(code, {
      onSuccess: (tokens) => {
        Logger.done('MFA submit')
        signIn(tokens)
        if (returnToUrl) {
          signInExternalHostWithCustomRedirect(returnToUrl)
        } else {
          signInExternalHost()
        }
      },
      onFailure: (err) => {
        loadingRef.current.complete()
        Logger.error('MFA submit', err)
        setAlertType(ALERT_TYPES.UPDATE_FAILED)
        setErrorMessage(err.message || JSON.stringify(err))
      }
    })
  }

  const renderAlert = () => {
    if (alertType === ALERT_TYPES.UPDATE_FAILED) {
      return (
        <div className={styles.alert}>
          {errorMessage}
        </div>
      )
    }
  }

  return (
    <div className={styles.wrapper}>
      <LoadingBar color='#ffffff' ref={loadingRef} />
      <div className={styles.decorativeCircleTop}></div>
      <div className={styles.decorativeCircleBottom}></div>

      <div className={styles.mainContent}>
        <div className={styles.formWrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="Blueleaf"
              src={ BLUELEAF_LOGO_WHITE }
              className={styles.logo}
            />
          </div>

          <div className={styles.formCard}>
            { renderAlert() }

            <div className={styles.formHeader}>
              <h2 className={styles.title}>Verify your identity</h2>
              <p className={styles.subtitle}>Two-factor authentication</p>
            </div>

            <form id="mfa-form" onSubmit={handleSubmit}>
              <div className={styles.formDescription}>
                We've sent a temporary access code according to your contact preference. Please check your email or phone number ending {destination}
              </div>

              <div className={styles.fieldGroup}>
                <label className={styles.label}>
                  Enter code
                </label>
                <input
                  className={styles.input}
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Enter 6-digit code"
                  maxLength="6"
                  autoComplete="one-time-code"
                  autoFocus
                />
              </div>

              <input
                id="submit-btn"
                className={styles.submitButton}
                type="submit"
                value="Verify"
              />
              <a
                id="sign-in-btn"
                className={styles.resendLink}
                href="/"
              >
                Didn't receive your code? Try login again.
              </a>
            </form>
          </div>

          <div className={styles.supportContainer}>
            <span className={styles.supportText}>
              Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                Contact support
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <p className={styles.footerText}>
          © 2010–2026 Blueleaf Wealth, Inc. All rights reserved. Patent pending.
        </p>
      </div>
    </div>
  )
}
